import { BASE_IMAGE_URL } from '../../constants';

export const VerticalsEnum = {
  CreditCards: 'credit_cards',
  Insurance: 'insurance',
  Mortgages: 'mortgages',
  PersonalLoans: 'personal_loans',
  SmallBusiness: 'small_business',
  Banking: 'banking',
  Investing: 'investing',
  StudentLoans: 'student_loans',
};

export const SHOPPING_TABS = [
  VerticalsEnum.CreditCards,
  VerticalsEnum.Insurance,
  VerticalsEnum.Mortgages,
  VerticalsEnum.PersonalLoans,
  VerticalsEnum.SmallBusiness,
  VerticalsEnum.Banking,
  VerticalsEnum.Investing,
  VerticalsEnum.StudentLoans,
];

export const SHOPPING_TABS_CONTENT = {
  [VerticalsEnum.CreditCards]: {
    label: 'CREDIT CARDS',
    backgroundColor: '#f9fff9',
    mainText: 'Our Nerds researched 400+ credit cards so you don’t have to.',
    cta: {
      label: 'Compare Credit Cards',
      url: 'https://www.nerdwallet.com/the-best-credit-cards',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/cc_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/cc_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/cc_hero_375.png?v=2`,
      alt: 'Credit Card Hero Image',
    },
  },
  [VerticalsEnum.Insurance]: {
    label: 'INSURANCE',
    backgroundColor: '#f2fff2',
    mainText:
      'Our Nerds researched 700+ auto insurance companies so you don’t have to.',
    cta: {
      label: 'Compare Car Insurance',
      url: 'http://nerdwallet.com/p/insurance/car-insurance',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/insurance_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/insurance_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/insurance_hero_375.png?v=2`,
      alt: 'Insurance Hero Image',
    },
  },
  [VerticalsEnum.Mortgages]: {
    label: 'MORTGAGES',
    backgroundColor: '#DCF5E9',
    mainText: 'Our Nerds researched 50+ mortgage lenders so you don’t have to.',
    cta: {
      label: 'Compare Mortgage Rates',
      url: 'https://www.nerdwallet.com/best/mortgages/mortgage-lenders',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/mortgages_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/mortgages_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/mortgages_hero_375.png?v=2`,
      alt: 'Mortgages Hero Image',
    },
  },
  [VerticalsEnum.PersonalLoans]: {
    label: 'PERSONAL LOANS',
    backgroundColor: '#CEF0E1',
    mainText:
      'Our Nerds researched 35+ personal loan lenders so you don’t have to.',
    cta: {
      label: 'Compare Personal Loans',
      url: 'https://www.nerdwallet.com/personal-loans',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/personal_loans_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/personal_loans_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/personal_loans_hero_375.png?v=2`,
      alt: 'Personal Loans Hero Image',
    },
  },
  [VerticalsEnum.SmallBusiness]: {
    label: 'SMALL BUSINESS',
    backgroundColor: '#bfebda',
    mainText:
      'Our Nerds researched 250+ small-business products so you don’t have to.',
    cta: {
      label: 'Compare Business Loans',
      url: 'https://www.nerdwallet.com/small-business-loans',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/smb_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/small_business_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/small_business_hero_375.png?v=2`,
      alt: 'Small Business Hero Image',
    },
  },
  [VerticalsEnum.Banking]: {
    label: 'BANKING',
    backgroundColor: '#b1e6d2',
    mainText:
      'Our Nerds researched 100+ financial institutions so you don’t have to.',
    cta: {
      label: 'Compare Bank Accounts',
      url: 'https://www.nerdwallet.com/best/banking/high-yield-online-savings-accounts',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/banking_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/banking_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/banking_hero_375.png?v=2`,
      alt: 'Banking Hero Image',
    },
  },
  [VerticalsEnum.Investing]: {
    label: 'INVESTING',
    backgroundColor: '#a3e1ca',
    mainText:
      'Our Nerds researched 60+ investment account providers so you don’t have to.',
    cta: {
      label: 'Compare Online Brokers',
      url: 'https://nerdwallet.com/best/investing/online-brokers-for-stock-trading',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/investing_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/investing_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/investing_hero_375.png?v=2`,
      alt: 'Investing Hero Image',
    },
  },
  [VerticalsEnum.StudentLoans]: {
    label: 'STUDENT LOANS',
    backgroundColor: '#95dcc3',
    mainText:
      'Our Nerds researched 35+ student loan lenders so you don’t have to.',
    cta: {
      label: 'Compare Student Loans',
      url: 'https://www.nerdwallet.com/best/loans/student-loans/private-student-loans',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/student_loans_hero_image.png?v=2`,
      tabletURL: `${BASE_IMAGE_URL}/student_loans_hero_768.png?v=3`,
      mobileURL: `${BASE_IMAGE_URL}/student_loans_hero_375.png?v=2`,
      alt: 'Student Loans Hero Image',
    },
  },
};

/** zIndexes are defined by the selected tab.
 * For example: when PL is selected, Mortgages is ahead of Insurance and this is ahead of CC,
 *   but the tabs at the right of PL follows another pattern: SMB -> Banking -> Investing -> SL.
 */
export const SELECTED_TAB_Z_INDEX_VALUES = {
  [VerticalsEnum.CreditCards]: {
    [VerticalsEnum.CreditCards]: 100,
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.Mortgages]: 80,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.SmallBusiness]: 60,
    [VerticalsEnum.Banking]: 50,
    [VerticalsEnum.Investing]: 40,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.Insurance]: {
    [VerticalsEnum.CreditCards]: 90,
    [VerticalsEnum.Insurance]: 100,
    [VerticalsEnum.Mortgages]: 80,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.SmallBusiness]: 60,
    [VerticalsEnum.Banking]: 50,
    [VerticalsEnum.Investing]: 40,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.Mortgages]: {
    [VerticalsEnum.CreditCards]: 80,
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.Mortgages]: 100,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.SmallBusiness]: 60,
    [VerticalsEnum.Banking]: 50,
    [VerticalsEnum.Investing]: 40,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.PersonalLoans]: {
    [VerticalsEnum.CreditCards]: 70,
    [VerticalsEnum.Insurance]: 80,
    [VerticalsEnum.Mortgages]: 90,
    [VerticalsEnum.PersonalLoans]: 100,
    [VerticalsEnum.SmallBusiness]: 60,
    [VerticalsEnum.Banking]: 50,
    [VerticalsEnum.Investing]: 40,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.SmallBusiness]: {
    [VerticalsEnum.CreditCards]: 60,
    [VerticalsEnum.Insurance]: 70,
    [VerticalsEnum.Mortgages]: 80,
    [VerticalsEnum.PersonalLoans]: 90,
    [VerticalsEnum.SmallBusiness]: 100,
    [VerticalsEnum.Banking]: 50,
    [VerticalsEnum.Investing]: 40,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.Banking]: {
    [VerticalsEnum.CreditCards]: 50,
    [VerticalsEnum.Insurance]: 60,
    [VerticalsEnum.Mortgages]: 70,
    [VerticalsEnum.PersonalLoans]: 80,
    [VerticalsEnum.SmallBusiness]: 90,
    [VerticalsEnum.Banking]: 100,
    [VerticalsEnum.Investing]: 40,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.Investing]: {
    [VerticalsEnum.CreditCards]: 40,
    [VerticalsEnum.Insurance]: 50,
    [VerticalsEnum.Mortgages]: 60,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.SmallBusiness]: 80,
    [VerticalsEnum.Banking]: 90,
    [VerticalsEnum.Investing]: 100,
    [VerticalsEnum.StudentLoans]: 30,
  },
  [VerticalsEnum.StudentLoans]: {
    [VerticalsEnum.CreditCards]: 30,
    [VerticalsEnum.Insurance]: 40,
    [VerticalsEnum.Mortgages]: 50,
    [VerticalsEnum.PersonalLoans]: 60,
    [VerticalsEnum.SmallBusiness]: 70,
    [VerticalsEnum.Banking]: 80,
    [VerticalsEnum.Investing]: 90,
    [VerticalsEnum.StudentLoans]: 100,
  },
};
